import InnerComponent from '@Components/Admin/Integration/BusyIntegration/BusyHome';
import orgContainer from '@Components/AppContainer';

const BusyHome = () => ((orgContainer(InnerComponent)));
export default BusyHome;
